import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

const stripePromise = loadStripe(process.env.REACT_APP_LOAD_STRIPE_KEY_PRODUCTION);

export default function CheckoutButton({ priceId, cognitoUserId, fullName, email }) {

    const createCheckoutSession = async (priceId) => {
        console.log({
            priceId: priceId,
            cognitoUserId: cognitoUserId,
            fullName: fullName,
            email: email
        })
        const stripe = await stripePromise;

        axios.post('https://firewatch-api.space-eyes.com/user/stripe-products', {
            priceId: priceId,
            cognitoUserId: cognitoUserId,
            fullName: fullName,
            email: email
        }).then((response) => {
            const { id, url } = response.data;
            stripe.redirectToCheckout({ sessionId: id });
            console.log(response.data);
        }).catch((err) => {
            console.log(err);
        });
    };


    return (
        <div className='login-right-container-button' onClick={() => createCheckoutSession(priceId)}>
            Subscribe
        </div>
    );
};
